import { render, staticRenderFns } from "./ContestEnd.vue?vue&type=template&id=36e43949&"
import script from "./ContestEnd.vue?vue&type=script&lang=js&"
export * from "./ContestEnd.vue?vue&type=script&lang=js&"
import style0 from "./ContestEnd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports